// extracted by mini-css-extract-plugin
export default {"poiContainer":"poiContainer-FzTAF1MborsosdKUYYe8"};